import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Manifesto from "@/components/Manifesto";
import Services from "@/components/Services";
import Marquee from "@/components/Marquee";
import TheGap from "@/components/TheGap";
import Impact from "@/components/Impact";
import Donate from "@/components/Donate";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

const Home = () => (
  <main data-testid="home-page" className="bg-[#F4F1EA] text-[#1A1A1A] overflow-hidden">
    <Navbar />
    <Hero />
    <Manifesto />
    <Services />
    <Marquee />
    <TheGap />
    <Impact />
    <Donate />
    <Contact />
    <Footer />
  </main>
);

export default Home;
